module.exports = {"closeButtonText":"Cerca","thumbNailAlt":"Previsualizar imagen","next":"Siguiente página","previous":"Pagina anterior","addNote":"Agregar una nota..."}


//////////////////
// WEBPACK FOOTER
// ./translations/es-la.json
// module id = 25
// module chunks = 0